// extracted by mini-css-extract-plugin
export default {"siWrapper":"preview-tab_siWrapper__qsbI-"};